var _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVanDefault = function SvgVanDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.8,
    d: "M14.593 14.84a1.061 1.061 0 1 1-2.123 0 1.061 1.061 0 0 1 2.123 0ZM36.425 14.84a1.061 1.061 0 1 1-2.123 0 1.061 1.061 0 0 1 2.123 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeLinecap: "round",
    strokeWidth: 0.774,
    d: "m10.655 14.643-3.002-.31a.774.774 0 0 1-.688-.67l-.06-.458a.4.4 0 0 1 .396-.451v0a.4.4 0 0 0 .4-.386l.276-7.616a2.32 2.32 0 0 1 2.32-2.237h5.756q0 0 0 0h14.94c.203 0 .394.079.539.221 1.496 1.48 3.47 3.514 4.649 4.759 0 0 2.268.46 4.293.884.147.031.259.12.275.269.081.72.077 3.04-.018 5.136a.77.77 0 0 1-.645.72l-2.034.334m-21.754 0h16.357"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M28.639 7.237c1.555 0 3.025-.003 4.485 0 .301 0 .475-.322.29-.56-.622-.798-1.643-1.902-2.22-2.48a.7.7 0 0 0-.43-.205c-.798-.078-1.817-.05-2.494-.052a.4.4 0 0 0-.405.398v2.126c0 .427.347.774.774.773Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.532,
    cy: 14.839,
    r: 2.536,
    stroke: "#1E242F",
    strokeWidth: 0.774
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M37.897 14.84a2.536 2.536 0 1 1-5.07 0 2.536 2.536 0 0 1 5.07 0Z"
  })));
};
export default SvgVanDefault;